import i18n from '@/i18n'
export default {
  columns: (vm) => {
    return [{
      title: i18n.t('area.columns.127167-0'),
      type: 'index',
      width: 120,
      align: 'center',
      indexMethod: (row) => {
        if (vm.page) {
          return (vm.page.page - 1) * vm.page.size + row._index + 1;
        } else {
          return row._index + 1;
        }
      }
    },{
      title: i18n.t('area.columns.127167-1'),
      key: 'Name',
      resizable: true,
      minWidth: 160,
      sortable: true,
      align: 'center'
    },
    {
      title: i18n.t('area.columns.127167-2'),
      key: 'CreateUser',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center'
    },
    {
      title: i18n.t('area.columns.127167-3'),
      key: 'CreateDate',
      resizable: true,
      sortable: true,
      minWidth: 190,
      align: 'center'
    },
    {
      title: i18n.t('area.columns.127167-4'),
      key: 'action',
      width: 150,
      align: 'center',
      render: (h, params) => {
        return h('div', [
          h('Button', {
            props: {
              type: 'info',
              size: 'small'
            },
            style: {
              marginRight: '5px'
            },
            on: {
              click: () => {
                vm.editClick(params.row)
              }
            }
          }, i18n.t('area.columns.127167-5')),
          h('Button', {
            props: {
              type: 'error',
              size: 'small'
            },
            on: {
              click: () => {
                vm.$Modal.confirm({
                  title: i18n.t('area.columns.127167-6'),
                  content: `<p>是否删除"${params.row.Name}"</p>`,
                  onOk: () => {
                    vm.removeClick(params.row)
                  },
                  onCancel: () => {}
                });

              }
            }
          }, i18n.t('area.columns.127167-8'))
        ]);
      }
    }]
  }
}



// WEBPACK FOOTER //
// ./src/components/useGas/views/area/columns.js